import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'app-modal-question',
  templateUrl: './modal-question.component.html',
  styleUrls: ['./modal-question.component.scss'],
})
export class ModalQuestionComponent implements OnInit {

  @Input() pregunta: any = {
    Descripcion: '',
    ID_Bodega: 0,
    ID_CalificanosRegion: 0,
    ID_CalificaPregunta: 0,
    ID_Programa: 0,
    ID_Region: 0,
    ID_Tendero: 0,
    MejoraTitulo: '',
    NUD: 0
  }
  @Output() respuestaOpcion = new EventEmitter<{ valor: number, comentario: string }>()
  @Output() cambiarPregunta = new EventEmitter<boolean>(false)
  public opcionSeleccionada = false
  public preguntaAbierta = ''
  public facesIcons = [
    {
      source: '/assets/icon/sad-face-icon.svg',
      status: false
    },
    {
      source: '/assets/icon/normal-face-icon.svg',
      status: false
    },
    {
      source: '/assets/icon/happy-face-icon.svg',
      status: false
    }
  ]
  constructor() { }

  ngOnInit() { }

  public changeStatus(position: number) {
    this.opcionSeleccionada = true
    this.facesIcons.forEach((face, index) => {
      face.status = position === index ? true : false
    })
    this.respuestaOpcion.emit({ valor: position, comentario: this.preguntaAbierta })
  }

  public siguientePregunta() {
    this.cambiarPregunta.emit(true)
  }

}
